function toggleSidebarMenu() {
  var sidebar = document.getElementsByClassName('collapsible-body');
  if (sidebar.length === 0) {
    return;
  }

  if (sidebar[0].style.display === 'none') {
    sidebar[0].style.display = 'block';
  } else {
    sidebar[0].style.display = 'none';
  }
}